import React, { useState } from 'react';
import './NewBodilyPart.css';

const NewBodilyPart = ({ setShowSaved, selectedDoctor, setEditBookArray, editBookArray, manualSetDoctors, setSelectedItem }) => {
    const [newBodyPart, setNewBodyPart] = useState('');
    const [errorBodyPart, setErrorBodyPart] = useState('');
    const [locationsToSend, setLocationsToSend] = useState([]);
    const [bodilyPartsToSend, setBodilyPartsToSend] = useState([]);

    const csrfToken = localStorage.getItem('csrfToken');

    const handleChange = (event) => {
        setErrorBodyPart('');
        setNewBodyPart(event.target.value);
    };

    const handleClick = () => {


        fetch(`https://apps.laoss.com/api/v1/new_bodily_part`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-Token': csrfToken
            },
            body: JSON.stringify({ doctor_id: selectedDoctor.doctor.id, bodily_part: newBodyPart })
        })
        .then((response) => response.json())
        .then((responseJson) => {
            if (responseJson.message) {
                console.error('Error 1 new_body_part:');
                setErrorBodyPart(responseJson.message);
            } else {
                const bookArray = [
                    {
                        title: 'Age Groups',
                        lines: responseJson.doctor.age_groups,
                        icon: 'fa-calendar-alt'
                    },
                    {
                        title: 'Body Parts',
                        lines: responseJson.doctor.bodily_parts,
                        icon: 'fa-universal-access'
                    },
                    {
                        title: 'Insurances',
                        lines: responseJson.doctor.insurances,
                        icon: 'fa-file-contract'
                    },
                    {
                        title: 'Offices',
                        lines: responseJson.doctor.offices,
                        icon: 'fa-building'
                    }
                ]
                

                const forManualDoctors = responseJson.doctor.doctors_scheduler;
                
                const updatedBookArray = editBookArray.map((book) => {
                    if (book.title === 'Body Parts') {
                        const updatedLines = book.lines.map((line) => {
                            const bodily_part = responseJson.doctor.bodily_parts.find((ag) => ag.name === line.name);
                            if (bodily_part) {
                                return {
                                    ...line,
                                    covered: true,
                                    
                                };
                            }
                            return line;
                        });
                        
                        responseJson.doctor.bodily_parts.forEach((bodily_part) => {
                            const existingLine = updatedLines.find((line) => line.name === bodily_part.name);
                            if (!existingLine) {
                                updatedLines.push({
                                    name: bodily_part.name,
                                    id: bodily_part.id,
                                    covered: true

                                });
                            }
                        });
                        
                        return {
                            ...book,
                            lines: updatedLines
                        };
                    }
                    return book;
                });
                
                
                setEditBookArray(updatedBookArray);
                
                setLocationsToSend([]);
                setBodilyPartsToSend([]);
                manualSetDoctors(forManualDoctors);
                setShowSaved(true); // Show the "Saved" message
                setSelectedItem(null);
                setNewBodyPart('');
                setTimeout(() => {
                    setShowSaved(false); // Hide the "Saved" message after 1 second
                }, 1500);
            }
        })
        .catch(error => {
            console.error('Error 2 new_body_part:', error);
        })
    };

    const handleKeyDown = (event) => {

        if (newBodyPart && event.key === 'Enter') {
            handleClick();
        }
    };

    return (
        <div className="new-bodily-part">
            {errorBodyPart && <p style={{ color: 'red', textShadow: 'none', margin: '0px 5px 0px 5px', padding: '0px 5px 0px 5px' }}>{errorBodyPart}</p>}
            <input
                type="text"
                value={newBodyPart}
                onChange={handleChange}
                onKeyDown={handleKeyDown} // Call handleKeyDown on key press
                placeholder="Enter New Body Part"
                style={{ height: '28px', fontSize: '1rem', width: '70%', margin: '0px 10px 0px 0px', padding: '0px 0px 0px 15px' }}
            />
            <button onClick={handleClick}>Add</button>
        </div>
    );
};

export default NewBodilyPart;
